import { motion } from "framer-motion";
import { NavLink } from "react-router-dom";
import {
  Info,
  ClipboardCheck,
  ArrowRight,
  GraduationCap,
  Clock,
  Users,
  ChevronRight,
} from "lucide-react";

import DataFetcher from "../../hooks/DataFetcherPosgrados";
import Breadcumbs from "../../components/Breadcumbs";
import ConectUs from "../../components/ConectUs";
import BannerGeneral from "../../components/BannerGeneral";
import HeroBanner from "../../components/posgrados/HeroBanner";
import SubMenuAncla from "../../components/posgrados/SubMenuAncla";
import InfoCards from "../../components/posgrados/InfoCards";
import Modalidad from "../../components/posgrados/Modalidad";
import Duracion from "../../components/posgrados/Duracion";
import Campo from "../../components/posgrados/Campo";
import Malla from "../../components/posgrados/Malla";
import Facultad from "../../components/posgrados/Facultad";
import SubMenuAnclaGrado from "../../components/posgrados/SubMenuAnclaGrado";
import MallaGrado from "../../components/posgrados/MallaGrado";
import PosgradoPagos from "../../components/PosgradoPagos";
import HeroBannerGrado from "../../components/posgrados/HeroBannerGrado";
import EnLineaPagos from "../../components/Enlineapagos";
import Elementos from "../../components/posgrados/Elementos";
import Accordion from "../../components/Accordion";
import Investigacion from "../../components/posgrados/Investigacion";
import Vinculacion from "../../components/posgrados/Vinculacion";
import DocentesSection from "../../components/posgrados/DocentesSection";
import RequisitosSection from "../../components/posgrados/RequisitosSection";

// 1. URL CORRECTA: Pide "field_url_postulacion_en_linea" para que el Fetcher lo reciba y lo procese
const url =
  "https://be-ofertas.utpl.edu.ec/jsonapi/node/carrera/be3fbf93-f2e8-456b-8bbd-15f5d1da7ef2" +
  "?include=field_imagen_portada.field_media_image,field_brochure,field_malla_curricular_linea,field_malla_curricular_modalidad," +
  "field_imagen_perfil_ingreso.field_media_image," +
  "field_imagen_campo_ocupacional.field_media_image," +
  "field_imagen_perfil_de_egreso.field_media_image," +
  "field_imagen_director.field_media_image," +
  "field_imagen_perfil_profesional.field_media_image," +
  "field_nuestros_docentes.field_imagen_docente.field_media_image" +
  "&fields[node--carrera]=title,field_brochure,field_malla_curricular_linea,field_malla_curricular_modalidad,field_texto_portada,field_imagen_portada,field_publicado,field_url_postulacion_en_linea,field_publicado_presencial,field_url_postulacion_presencial," +
  "field_titulo,field_perfil_de_egreso,field_imagen_perfil_de_egreso,field_perfil_de_egreso_amplio,field_facultad,field_descripcion_malla,field_modalidad,field_etiqueta_modalidad,field_costo_en_linea,field_costo_presencial,field_descripcion_carrera,field_imagen_campo_ocupacional,field_campo_ocupacional," +
  "field_duracion,field_inicio_clases,field_resolucion,field_etiqueta_modalidad,field_imagen_perfil_profesional,field_imagen_perfil_ingreso,field_perfil_de_ingreso,field_malla_curricular,field_perfil_profesional," +
  "field_por_que_estudiar,field_texto_director,field_imagen_director,field_nuestros_docentes,field_requisitos_de_postulacion,field_proceso_matricula_presenci," +
  "field_titulo_elementos,field_diplomados,field_certificaciones,field_microcredenciales," +
  "field_bloque1,field_bloque2,field_testimoniales,field_investigacion,field_vinculacion" +
  "&fields[node--docente]=title,field_imagen_docente,field_contenido," +
  "&fields[media--image]=field_media_image" +
  "&fields[file--file]=uri";
// Función auxiliar para extraer el ID del video de YouTube (soporta varios formatos de URL)
const getYouTubeEmbedUrl = (url) => {
  if (!url) return null;
  const regExp =
    /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
  const match = url.match(regExp);
  return match && match[2].length === 11
    ? `https://www.youtube.com/embed/${match[2]}`
    : null;
};

const processContent = (html) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, "text/html");

  doc.querySelectorAll("img").forEach((img) => {
    const src = img.getAttribute("src");

    if (src && !src.startsWith("http")) {
      img.setAttribute(
        "src",
        `https://be-ofertas.utpl.edu.ec/${src.replace(/^\/+/, "")}`,
      );
    }
  });

  return doc.body.innerHTML;
};

const DataDisplay = ({ data }) => {
  const fadeUp = {
    initial: { y: 40 },
    whileInView: { y: 0 },
    transition: { duration: 0.6 },
  };

  return (
    <div className="bg-white overflow-hidden mt-16">
      {/* HERO */}
      <HeroBannerGrado
        image={data?.imagen_portada}
        content={data?.field_texto_portada}
        showApply={data?.field_publicado}
        applyUrl={data?.enlace_enlinea?.uri}
        showApplyPresencial={data?.field_publicado_presencial}
        applyUrlPresencial={data?.field_url_postulacion_presencial?.uri}
        brochure={data.brochure}
      />
      {/* BREADCRUMBS */}
      <div className="border-b border-slate-200 bg-white">
        <div className="mb-6">
          <Breadcumbs
            content={
              <div className="flex items-center gap-2 text-sm">
                <a href="/en-linea">
                  <Modalidad value={data.modalidad}></Modalidad>
                </a>
                <ChevronRight size={16} className="text-gray-400" />
                <p className="text-[#febe10] font-bold"> {data.titulo}</p>
              </div>
            }
          />
        </div>
      </div>
      {/* INFO CARDS  */}
      <InfoCards
        titulo={data.titulo_recibir}
        inversion={
          <>
            {data.precio_enlinea && data.precio_presencial ? (
              <ul>
                <li>En línea: {data.precio_enlinea}</li>
                <li>Presencial: {data.precio_presencial}</li>
              </ul>
            ) : (
              <>
                {data.precio_enlinea && <p> {data.precio_enlinea}</p>}
                {data.precio_presencial && <p> {data.precio_presencial}</p>}
              </>
            )}

            <span className="block text-[9px] font-normal text-slate-400 leading-snug">
              Los costos son referenciales y pueden variar según el número de
              créditos, becas y descuentos a los que acceda cada estudiante.
            </span>
          </>
        }
        inicio={data.inicio}
        facultad={
          <>
            <Facultad value={data.facultad}></Facultad>
          </>
        }
        duracion={
          <>
            <Duracion value={data.duracion}></Duracion>
          </>
        }
        modalidad={
          <>
            <Modalidad value={data.modalidad}></Modalidad>

            {data.etiqueta_modalidad && (
              <div
                dangerouslySetInnerHTML={{
                  __html: data.etiqueta_modalidad,
                }}
              />
            )}
          </>
        }
        resolucion={
          <div
            dangerouslySetInnerHTML={{
              __html: data.resolucion,
            }}
          />
        }
      ></InfoCards>
      {data.descripcion_carrera && (
        <div className="max-w-6xl mx-auto py-24 px-6 lg:px-0 [&_h2]:font-bold">
          <div
            className="[&_img]:w-60 [&_img]:m-auto "
            dangerouslySetInnerHTML={{
              __html: processContent(data.descripcion_carrera),
            }}
          />
        </div>
      )}
      {/* PERFIL profesional */}
      <section id="profesional" className="py-24  bg-slate-50 ">
        <div className="max-w-6xl mx-auto grid lg:grid-cols-2 gap-20 items-center py-4">
          <motion.div {...fadeUp}>
            <div className="px-8 lg:px-0">
              <div
                className=" 
                [&_h2]:font-bold"
                dangerouslySetInnerHTML={{
                  __html: data.perfil_profesional,
                }}
              />
            </div>
          </motion.div>

          <motion.div {...fadeUp}>
            <img
              src={data.imagen_perfilprofesional}
              alt="Perfil"
              className="w-full h-[450px] object-cover rounded-3xl shadow-2xl"
            />
          </motion.div>
        </div>
      </section>
      {/*campo ocupacional */}
      <section id="campo" className="py-24  ">
        <div className="max-w-6xl mx-auto grid lg:grid-cols-2 gap-20 items-center py-4">
          <motion.div {...fadeUp}>
            <img
              src={data.imagen_campo}
              alt="Perfil"
              className="w-full h-[500px] object-cover rounded-3xl shadow-2xl"
            />
          </motion.div>

          <motion.div {...fadeUp}>
            <div className="px-8 lg:px-0">
              <div
                className=" 
                [&_h2]:font-bold"
                dangerouslySetInnerHTML={{
                  __html: data.campo_ocupacional,
                }}
              />
            </div>
          </motion.div>
        </div>
      </section>
      {/* PERFIL EGRESO */}
      {data.egreso && (
        <section id="egreso" className="py-24 bg-slate-50">
          <div className="max-w-6xl mx-auto grid lg:grid-cols-2 gap-20 items-start py-4">
            <motion.div {...fadeUp}>
              <div className="px-8 lg:px-0">
                <div
                  className="   [&_h2]:font-bold    "
                  dangerouslySetInnerHTML={{
                    __html: data.egreso,
                  }}
                />
                {data.egreso_amplio && (
                  <div className="mt-4">
                    <Accordion
                      title="Más información"
                      content={
                        <div
                          dangerouslySetInnerHTML={{
                            __html: data.egreso_amplio,
                          }}
                        />
                      }
                    />
                  </div>
                )}{" "}
              </div>
            </motion.div>

            <motion.div {...fadeUp}>
              <img
                src={data.imagen_perfil}
                alt="Perfil"
                className="w-full h-[450px] object-cover rounded-3xl shadow-2xl"
              />
            </motion.div>
          </div>
        </section>
      )}
      <MallaGrado
        title={data.descripcion_malla}
        content={data.malla}
        malla_enlinea={data.malla_enlinea}
        malla_presencial={data.malla_presencial}
      ></MallaGrado>
      {data.titulo_elementos && (
        <>
          <Elementos
            titulo={data.titulo_elementos}
            diplomados={data.diplomados}
            certificaciones={data.certificaciones}
            microcredenciales={data.microcredenciales}
          ></Elementos>
        </>
      )}
      {/* El contenedor principal solo se renderiza si al menos uno de los bloques tiene información */}
      {(data.bloque1 || data.bloque2) && (
        <div>
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.35 }}
          >
            <h2 className="text-center max-w-3xl m-auto font-bold mb-6">
              {" "}
              Una experiencia de aprendizaje{" "}
              <span className="font-montserrat text-[#febe10]">flexible</span>
            </h2>
          </motion.div>
          <div className="flex flex-wrap justify-center gap-6 w-full max-w-6xl mx-auto pb-24">
            {/* Columna 1: Aprendizaje Asíncrono (Bloque 1) */}
            {data.bloque1 && (
              <motion.div
                className="w-full md:w-[calc(50%-12px)] p-6 bg-white rounded-xl border border-slate-200/80 shadow-sm"
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.35, delay: 0.5 }}
              >
                <div className="flex items-center gap-3 mb-4">
                  <div className="p-2 bg-slate-100 rounded-lg flex-shrink-0">
                    <Clock className="w-6 h-6" style={{ color: "#004270" }} />
                  </div>
                </div>

                <div
                  className="[&_h2]:font-bold "
                  dangerouslySetInnerHTML={{
                    __html: data.bloque1,
                  }}
                />
              </motion.div>
            )}

            {/* Columna 2: Aprendizaje Síncrono (Bloque 2) */}
            {data.bloque2 && (
              <motion.div
                className="w-full md:w-[calc(50%-12px)] p-6 bg-white rounded-xl border border-slate-200/80 shadow-sm"
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.35, delay: 1 }}
              >
                <div className="flex items-center gap-3 mb-4">
                  <div className="p-2 bg-slate-100 rounded-lg flex-shrink-0">
                    <Users className="w-6 h-6" style={{ color: "#004270" }} />
                  </div>
                </div>
                <div
                  className="[&_h2]:font-bold "
                  dangerouslySetInnerHTML={{
                    __html: data.bloque2,
                  }}
                />
              </motion.div>
            )}
          </div>
        </div>
      )}
      <section id="estudiar" className="bluebg">
        <div className="max-w-5xl mx-auto px-6 py-24">
          {/* Encabezado */}

          <div className="flex items-center gap-4">
            <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-[#febe10] shadow-lg">
              <GraduationCap className="h-7 w-7 text-[#004270]" />
            </div>
          </div>

          {/* Contenido */}
          <div
            className="
        prose prose-lg max-w-none
        [&_h2]:font-bold
         [&_h2]:mb-6

        [&_img]:rounded-2xl
        [&_img]:shadow-lg
      "
            dangerouslySetInnerHTML={{
              __html: data.estudiar,
            }}
          />
        </div>
      </section>
      {/* DIRECTOR */}
      {data.director && (
        <section className="py-24 bg-white">
          <div className="max-w-6xl mx-auto  grid lg:grid-cols-2 gap-20 items-center">
            <motion.div {...fadeUp}>
              <img
                src={data.imagen_director}
                alt="Director"
                className="w-auto h-[550px] object-cover rounded-3xl shadow-2xl"
              />
            </motion.div>

            <motion.div className="px-10 lg:px-0" {...fadeUp}>
              <div
                className="
                [&_h4]:text-gray-600  
                [&_h4]:text-base  
                [&_h4]:uppercase 
                [&_h4]:mb-4 
                mt-6 link-with-arrow-1 "
                dangerouslySetInnerHTML={{
                  __html: data.director,
                }}
              />
            </motion.div>
          </div>
        </section>
      )}
      {/* DOCENTES */}
       <DocentesSection docentes={data.nuestros_docentes}></DocentesSection>

      {data.testimoniales && (
        <section className="bg-slate-50 py-24">
          <div className="w-full max-w-6xl mx-auto   px-6 ">
            <h2 className="font-bold text-center">Testimoniales</h2>
            <p className="text-center mb-4">
              Descubre cómo la formación de la UTPL ha impulsado el crecimiento
              académico y profesional de nuestra comunidad.
            </p>
            <div
              className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 [&_iframe]:w-full [&_iframe]:aspect-video [&_iframe]:h-auto [&_iframe]:rounded-2xl [&_iframe]:shadow-md [&_iframe]:border-0"
              dangerouslySetInnerHTML={{
                __html: data.testimoniales,
              }}
            />
          </div>{" "}
        </section>
      )}
      {data.investigacion && (
        <Investigacion content={data.investigacion}></Investigacion>
      )}
      {data.vinculacion && (
        <Vinculacion content={data.vinculacion}></Vinculacion>
      )}
      <RequisitosSection
            requisitosenlinea={data.requisitos}
            publicadoenlinea={data.field_publicado}
            enlaceenlinea={data.enlace_enlinea?.uri}
            requisitospresencial={data.requisitos_presencial}
            publicadopresencial={data.field_publicado_presencial}
            enlacepresencial={data.enlace_presencial?.uri}
          />
    

   
      {data.field_publicado && (
        <div className="mt-10 py-8">
          <div className="flex justify-center w-full">
            <p className="inline-flex items-center mb-4 px-4 py-1.5 text-xs font-bold text-[#004270] bg-gray-100 border border-slate-200/80 rounded-full shadow-sm">
              Modalidad en línea
            </p>
          </div>{" "}
          <ConectUs
            instagram="https://www.instagram.com/utplenlinea/"
            facebook="https://www.facebook.com/utplenlinea/"
            tiktok="https://www.tiktok.com/@utplenlinea"
          ></ConectUs>{" "}
        </div>
      )}

      {data.field_publicado_presencial && (
        <div className="  py-8">
          <div className="flex justify-center w-full">
            <p className="inline-flex items-center mb-4 px-4 py-1.5 text-xs font-bold text-[#004270] bg-gray-100 border border-slate-200/80 rounded-full shadow-sm">
              Modalidad presencial
            </p>
          </div>{" "}
          <ConectUs facebook="https://www.facebook.com/utplpresencial/"></ConectUs>{" "}
        </div>
      )}
    </div>
  );
};

export default function CarreraLogisticaTransporte() {
  return (
    <>
      <SubMenuAnclaGrado></SubMenuAnclaGrado>
      <DataFetcher url={url}>
        {(data) => <DataDisplay data={data} />}
      </DataFetcher>

      <BannerGeneral />
    </>
  );
}
